import AppConstants from '../constants/app.constants'
export default class HTTPUtils {
  static is401Error(axiosGeneralResponse) {
    return (
      axiosGeneralResponse &&
      axiosGeneralResponse.data &&
      axiosGeneralResponse.data.code === AppConstants.RESPONSE_401_ERROR_CODE
    )
  }

  /**
   * トークンの有効期限が切れているかどうかを確認します。
   * @param {ErrorResponse} error エラー応答
   * @returns トークンが期限切れの場合は true を返し、それ以外の場合は false を返します
   */
  static isExpiredTokenError(error) {
    return this.isHttpError(error, AppConstants.RESPONSE_401_ERROR_CODE)
  }

  static is502Error(error) {
    return this.isHttpError(error, AppConstants.RESPONSE_502_ERROR_CODE)
  }

  static is504Error(error) {
    return this.isHttpError(error, AppConstants.RESPONSE_504_ERROR_CODE)
  }

  /**
   * 403エラーかどうかを確認します。
   *
   * @param {ErrorResponse} error エラー応答
   * @returns 403エラーの場合は true を返し、それ以外の場合は false を返します
   */
  static is403Error(error) {
    return this.isHttpError(error, AppConstants.RESPONSE_403_ERROR_CODE)
  }

  static isHttpError(error, httpErrorCode) {
    return (
      error &&
      ((error.response && error.response.status === httpErrorCode) ||
        (error.data && error.data.code === httpErrorCode))
    )
  }

  static isForbiddenResponse(axiosGeneralResponse) {
    return (
      axiosGeneralResponse &&
      axiosGeneralResponse.data &&
      axiosGeneralResponse.data.msg === AppConstants.RESPONSE_403_ERROR_MSG
    )
  }

  static isInvalidResponse(axiosGeneralResponse) {
    return (
      !axiosGeneralResponse ||
      (axiosGeneralResponse.code && axiosGeneralResponse.code !== AppConstants.RESPONSE_200_OK_CODE) ||
      !axiosGeneralResponse.data ||
      !axiosGeneralResponse.data.code ||
      axiosGeneralResponse.data.code !== AppConstants.RESPONSE_200_OK_CODE
    )
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/http.util.js